import { LodgeStatus } from '../Marker/Marker.constants';
import { PropertyMarkerModel } from '../Marker/Marker.model';

export const MapDefaultSettings = {
  googleKey: '',
  center: [56.74971110497152, -111.42608642578125],
  zoom: 7,
  maxZoom: 15,
  dimensions: {
    height: '100vh', // This is 100% of the iframe
    width: '100%'
  },
  skyBaseKey: ''
};

export const MapTheme = [
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'administrative.province',
    elementType: 'geometry.stroke',
    stylers: [
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'landscape',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#000000'
      }
    ]
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'on'
      }
    ]
  },
  {
    featureType: 'transit.station.airport',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'on'
      }
    ]
  }
];

export const DemoGeoJson = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [
          [-111.58059, 56.34882],
          [-111.57979, 56.34905],
          [-111.5788, 56.34714],
          [-111.5786, 56.34699],
          [-111.5783, 56.3469],
          [-111.57797, 56.34686],
          [-111.57767, 56.34691],
          [-111.57716, 56.34709],
          [-111.56496, 56.35114],
          [-111.56434, 56.35144],
          [-111.56364, 56.35181],
          [-111.56314, 56.35202],
          [-111.56276, 56.35211],
          [-111.56248, 56.35211],
          [-111.56222, 56.35204],
          [-111.56185, 56.3517],
          [-111.56139, 56.35123],
          [-111.5482, 56.35567],
          [-111.51646, 56.36617],
          [-111.5024, 56.37085],
          [-111.47842, 56.37882],
          [-111.47025, 56.38142],
          [-111.46374, 56.38378],
          [-111.4585, 56.38583],
          [-111.44624, 56.39058],
          [-111.43587, 56.39442],
          [-111.42731, 56.3978],
          [-111.42176, 56.39992],
          [-111.41073, 56.40416],
          [-111.38805, 56.41286],
          [-111.37836, 56.41617],
          [-111.37161, 56.41917],
          [-111.36583, 56.42152],
          [-111.36294, 56.42247],
          [-111.36049, 56.42323],
          [-111.35802, 56.42386],
          [-111.35418, 56.42476],
          [-111.35062, 56.42541],
          [-111.34402, 56.42642],
          [-111.32709, 56.42913],
          [-111.31039, 56.43179],
          [-111.30292, 56.43297],
          [-111.30189, 56.43321],
          [-111.30029, 56.4337],
          [-111.29895, 56.43434],
          [-111.29805, 56.43494],
          [-111.29747, 56.43545],
          [-111.29702, 56.436],
          [-111.29649, 56.43692],
          [-111.29634, 56.43784],
          [-111.29634, 56.43841],
          [-111.29826, 56.45746],
          [-111.29925, 56.46737],
          [-111.30154, 56.49202],
          [-111.30159, 56.49242],
          [-111.30167, 56.49278],
          [-111.30176, 56.49324],
          [-111.30193, 56.49378],
          [-111.30226, 56.49466],
          [-111.30266, 56.49552],
          [-111.30516, 56.5],
          [-111.3117, 56.51167],
          [-111.31561, 56.51895],
          [-111.31726, 56.5219],
          [-111.31825, 56.52396],
          [-111.3186, 56.52541],
          [-111.31865, 56.52689],
          [-111.31834, 56.52911],
          [-111.31583, 56.54567],
          [-111.3153, 56.54886],
          [-111.31172, 56.57272],
          [-111.31141, 56.57564],
          [-111.31145, 56.57736],
          [-111.31174, 56.5788],
          [-111.31226, 56.58022],
          [-111.31318, 56.58189],
          [-111.31433, 56.5835],
          [-111.31517, 56.58459],
          [-111.31648, 56.58623],
          [-111.31947, 56.59007],
          [-111.32188, 56.59316],
          [-111.32249, 56.59393],
          [-111.32463, 56.59665],
          [-111.32633, 56.59885],
          [-111.32928, 56.60265],
          [-111.33069, 56.60445],
          [-111.33323, 56.60768],
          [-111.33551, 56.61064],
          [-111.33607, 56.61133],
          [-111.33714, 56.61296],
          [-111.33791, 56.61461],
          [-111.33836, 56.61629],
          [-111.33854, 56.6171],
          [-111.33908, 56.61987],
          [-111.34137, 56.63096],
          [-111.34269, 56.63741],
          [-111.3432, 56.63982],
          [-111.34328, 56.6407],
          [-111.34337, 56.64119],
          [-111.34339, 56.6416],
          [-111.34328, 56.64224],
          [-111.34317, 56.64276],
          [-111.34299, 56.64329],
          [-111.34279, 56.64381],
          [-111.34193, 56.64514],
          [-111.34127, 56.64619],
          [-111.33934, 56.64911],
          [-111.33887, 56.64995],
          [-111.3385, 56.65122],
          [-111.33847, 56.65189],
          [-111.33856, 56.65227],
          [-111.33869, 56.65282],
          [-111.33893, 56.65332],
          [-111.33926, 56.65388],
          [-111.33961, 56.65431],
          [-111.34279, 56.65794],
          [-111.34754, 56.66351],
          [-111.34828, 56.66471],
          [-111.34854, 56.66541],
          [-111.34869, 56.6659],
          [-111.34946, 56.66946],
          [-111.34992, 56.67159],
          [-111.35001, 56.67208],
          [-111.35002, 56.67219],
          [-111.35008, 56.67261],
          [-111.35036, 56.67407],
          [-111.35066, 56.6754],
          [-111.35103, 56.67723],
          [-111.35136, 56.67883],
          [-111.35214, 56.68257],
          [-111.35302, 56.68669],
          [-111.35297, 56.68682],
          [-111.35283, 56.6869],
          [-111.35251, 56.68697],
          [-111.3515, 56.68693],
          [-111.35099, 56.68692],
          [-111.35051, 56.68684],
          [-111.35013, 56.68669],
          [-111.34958, 56.68644]
        ]
      }
    }
  ]
};

export const DemoMarkers = [
  new PropertyMarkerModel({
    id: 'marker1',
    lat: 57.35616414789182,
    lng: -110.95367431640624,
    label: 'Birch Mountain Lodge',
    price: '$198',
    currency: 'CAD',
    connected: true,
    availability: LodgeStatus.SOLD_OUT,
    imgSrc: 'http://via.placeholder.com/600x400',
    imgAlt: 'Placeholder image'
  }),
  new PropertyMarkerModel({
    id: 'marker2',
    lat: 56.76476752576022,
    lng: -110.89599609375,
    imgSrc: 'http://via.placeholder.com/600x400',
    imgAlt: 'Placeholder image'
  }),
  new PropertyMarkerModel({
    id: 'marker3',
    lat: 56.95995224466898,
    lng: -112.08251953125,
    imgSrc: 'http://via.placeholder.com/600x400',
    imgAlt: 'Placeholder image'
  }),
  new PropertyMarkerModel({
    id: 'marker4',
    lat: 55.77039358162004,
    lng: -112.65106201171875,
    imgSrc: 'http://via.placeholder.com/600x400',
    imgAlt: 'Placeholder image'
  }),
  new PropertyMarkerModel({
    id: 'marker5',
    lat: 55.83060131378955,
    lng: -110.23681640625,
    imgSrc: 'http://via.placeholder.com/600x400',
    imgAlt: 'Placeholder image'
  }),
  new PropertyMarkerModel({
    id: 'marker6',
    lat: 56.4852452528355,
    lng: -112.664794921875
  }),
  new PropertyMarkerModel({
    id: 'marker7',
    lat: 56.26165975623278,
    lng: -112.664794921875,
    imgSrc: 'http://via.placeholder.com/600x400',
    imgAlt: 'Placeholder image'
  }),
  new PropertyMarkerModel({
    id: 'marker8',
    lat: 56.74971110497152,
    lng: -111.02783203125,
    imgSrc: 'http://via.placeholder.com/600x400',
    imgAlt: 'Placeholder image'
  })
];
